import { useCaptureEvent } from "@Light/app/analytics";
import { Button } from "@Light/components/page/Button";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import { Hyperlink } from "@Light/components/page/Hyperlink";
import { toTelHref } from "@Light/utils/phoneNumber";
import { LinkExternal01 } from "@untitledui/icons";
import { EnrollBottomSheet } from "../common/EnrollBottomSheet";

const EXPERIAN_FREEZE_URL = "https://www.experian.com/help/credit-freeze/";
const EXPERIAN_PHONE = "(888) 397-3742";

export type FrozenCreditBottomSheetProps = {
  open: boolean;
  onClose: () => void;
  deadline?: string;
};

export const FrozenCreditBottomSheet: React.FC<
  FrozenCreditBottomSheetProps
> = ({ open, onClose, deadline }) => {
  useCaptureEvent({
    event: "enroll_credit_frozen_viewed",
    condition: open,
  });

  return (
    <EnrollBottomSheet
      open={open}
      onClose={onClose}
      title="Is your credit frozen?"
      data-testid="credit-frozen-sheet"
      subtitle={
        <span className="flex flex-col gap-3.5">
          <span>
            We use Experian to process a soft credit check before enrollment is
            finalized. You can either unfreeze it directly on Experian&rsquo;s
            website or call them at{" "}
            <Hyperlink href={toTelHref(EXPERIAN_PHONE)}>
              {EXPERIAN_PHONE}
            </Hyperlink>
            .
          </span>
          <span>
            If you want to do this later, you can continue with your enrollment
            and let us know it has been completed
            {deadline ? ` by ${deadline}` : ""}.
          </span>
        </span>
      }
      footer={
        <ButtonFooter>
          <Button
            size="lg"
            className="w-full"
            href={EXPERIAN_FREEZE_URL}
            target="_blank"
            data-testid="credit-frozen-unfreeze"
          >
            Unfreeze credit at Experian
            <LinkExternal01 className="size-5" />
          </Button>
          <Button
            size="lg"
            buttonType="outline"
            className="w-full"
            onClick={onClose}
            data-testid="credit-frozen-back"
          >
            Go back
          </Button>
        </ButtonFooter>
      }
    />
  );
};
